var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dlgVisible,
        center: "",
        title: "提示",
        width: "80%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dlgVisible = $event
        },
      },
    },
    [
      _c(
        "avue-crud",
        {
          attrs: {
            data: _vm.dataEmployeeRepeat,
            option: _vm.optionEmployeeRepeat,
          },
        },
        [
          _c("template", { slot: "menuLeft" }, [
            _c("div", [
              _vm._v("\n\t\t\t\t\t本次投保的生效日期：\n\t\t\t\t\t"),
              _c(
                "span",
                { staticStyle: { "font-weight": "bold", color: "red" } },
                [_vm._v(_vm._s(_vm.effectiveDate))]
              ),
            ]),
            _c("div", [
              _vm._v("\n\t\t\t\t\t以下投保人员的保单在\n\t\t\t\t\t"),
              _c("span", [_vm._v(_vm._s(_vm.effectiveDate))]),
              _vm._v(
                "\n\t\t\t\t\t零时还未到期，请在本次“投保人员清单”中删除这些人员\n\t\t\t\t"
              ),
            ]),
          ]),
        ],
        2
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "medium" },
              on: {
                click: function ($event) {
                  _vm.dlgVisible = false
                },
              },
            },
            [_vm._v("我已知晓")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "medium", type: "primary" },
              on: { click: _vm.removeRepeatEmps },
            },
            [_vm._v("删除重复人员")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }